import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

let firebaseConfig = {
  apiKey: 'AIzaSyBs9kQU569-YykSnBgRHjpH3n_vWF5_mK8',
  authDomain: 'i-care-sales.firebaseapp.com',
  databaseURL: 'https://i-care-sales.firebaseio.com',
  projectId: 'i-care-sales',
  storageBucket: 'i-care-sales.appspot.com',
  messagingSenderId: '675964470434',
  appId: '1:675964470434:web:5eb4c217369a5ab8ed43fb',
  measurementId: 'G-MKWCPHQ32Q'
}

firebase.initializeApp(firebaseConfig)

let messaging = null

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
} else {
  console.log('FCM not supported')
}

export default messaging
